// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-toggle .toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: 74px;
  height: 40px;
  background-color: #c5c3c3;
  border-radius: 50px;
  position: relative;
  transition: 0.3s;
}
motes-toggle .toggle .switch {
  position: absolute;
  top: 5px;
  left: 7px;
  width: 30px;
  height: 30px;
  background-color: var(--motes-white);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 50%;
  transition: 0.3s;
}
motes-toggle .toggle.checked {
  background-color: var(--primary-color);
}
motes-toggle .toggle.checked .switch {
  transform: translateX(100%);
}
motes-toggle .toggle.disabled {
  opacity: 0.5;
  cursor: default;
}
motes-toggle .toggle.tiny {
  width: 38px;
  height: 20px;
}
motes-toggle .toggle.tiny .switch {
  top: 2px;
  left: 3px;
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-toggle/motes-toggle.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,sCAAA;AADZ;AAGY;EACI,2BAAA;AADhB;AAKQ;EACI,YAAA;EACA,eAAA;AAHZ;AAMQ;EACI,WAAA;EACA,YAAA;AAJZ;AAMY;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAJhB","sourcesContent":["motes-toggle {\n    .toggle {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        cursor: pointer;\n        width: 74px;\n        height: 40px;\n        background-color: #c5c3c3;\n        border-radius: 50px;\n        position: relative;\n        transition: 0.3s;\n\n        .switch {\n            position: absolute;\n            top: 5px;\n            left: 7px;\n            width: 30px;\n            height: 30px;\n            background-color: var(--motes-white);\n            box-shadow: 0px 3px 6px #00000029;\n            border-radius: 50%;\n            transition: 0.3s;\n        }\n\n        &.checked {\n            background-color: var(--primary-color);\n\n            .switch {\n                transform: translateX(100%);\n            }\n        }\n\n        &.disabled {\n            opacity: 0.5;\n            cursor: default;\n        }\n\n        &.tiny {\n            width: 38px;\n            height: 20px;\n\n            .switch {\n                top: 2px;\n                left: 3px;\n                width: 16px;\n                height: 16px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
